import { Card, Button } from 'react-bootstrap';
import { ArrowRightShort } from 'react-bootstrap-icons';

function Segment({ segment, segments, section, onSegmentSelect, onTestSelect }) {
  const currentIndex = (segments || []).findIndex(s => s.slug === segment.slug);

  let nextLabel = null;
  let nextAction = null;

  if (currentIndex === 0) {
    nextLabel = "Pre-Test";
    nextAction = () => onTestSelect("pre_test", section.id);
  } else if (currentIndex === segments.length -1) {
    const lastSegment = segments[segments.length - 1];
    if (!lastSegment.locked) {
      nextLabel = "PostTest";
      nextAction = () => onTestSelect("post_test", section.id);
    }
  } else {
    const nextSegment = segments[currentIndex + 1];
    if (nextSegment && !nextSegment.locked) {
      nextLabel = nextSegment.title;
      nextAction = () => onSegmentSelect(nextSegment.slug);
    }
  }

  return (
    <Card className="segment-card-purple">
      <Card.Body>
        <Card.Text>
          <div dangerouslySetInnerHTML={{ __html: segment?.content }} />
        </Card.Text>

        {nextAction && (
          <div className="d-flex justify-content-end mt-3">
            <Button
              className="purple-button"
              onClick={() => {
                nextAction();
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }}
            >
              {nextLabel} <ArrowRightShort fontSize="1.5rem" />
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default Segment;
